import Util from "./Util";
import axios from "axios";

class SessionDataStore {

    constructor() {
        this.callDumpInterval();
    }

    static instance = null;
    static createInstance = () => new SessionDataStore();

    static getInstance = () => {
        if (!SessionDataStore.instance) {
            SessionDataStore.instance = SessionDataStore.createInstance();
        }

        return SessionDataStore.instance;
    }

    dumpData = () => {
        
        let sessionData = Util.getSessionData();

        Util.setSessionData([]);

        if (sessionData.length > 0) {
			if (sessionData[0]['sessionId'])
				{
					return new Promise((resolve, reject) => {
							axios.post(process.env.REACT_APP_API_URL+"/api/v1/logs/create", sessionData)
								.then(res => {
									resolve();
								}).catch(err => {
									this.appendSessionData(sessionData);
									console.log('SessionDataStore err===', err);
								}
							);
					});
				}
        }
    }

    addSessionData = (data) => {
        let sessionData = Util.getSessionData();
        sessionData.push(data);
        Util.setSessionData(sessionData);
    }

    appendSessionData = (data) => {
        let sessionData = Util.getSessionData();

        data.forEach((sessionStoreData)=>{
            sessionData.push(sessionStoreData);
        });

        Util.setSessionData(sessionData);
    }

    callDumpInterval = () => {
        const that = this;

        setInterval(function() {
            that.dumpData();
        }, 15000);
    }
}

export default SessionDataStore;
